import React from 'react';
import { Paper, Button, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { push } from 'connected-react-router';
import { FormTextField, FormError } from '../../../components/Form';
import { required, validateEmail } from '../../../utils/validators';
import { user } from '../../../utils/api';

const StyledPaper = styled(Paper)`
  padding: 20px;
  width: 400px;
  margin: 15px auto;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

const StyledButton = styled(Button)`
  && {
    margin-top: 20px;
    margin-bottom: 10px;
  }
`;

const emailFieldValidation = [required, validateEmail];

const submitForgotPasswordForm = (values, dispatch) =>
  user
    .forgotPassword(values)
    .then(() => {
      dispatch(push('/success/forgot-password'));
    })
    .catch(({ response }) => {
      const errors = response.data.data;
      if (errors) {
        const validationErrors = errors.reduce(
          (acc, error) => ({
            ...acc,
            [error.field]: error.message
          }),
          {}
        );
        throw new SubmissionError(validationErrors);
      }
    });

const forgotPasswordForm = ({ handleSubmit, error }) => (
  <StyledPaper>
    <StyledForm onSubmit={handleSubmit(submitForgotPasswordForm)}>
      <Typography gutterBottom variant="headline">
        Create New Password
      </Typography>
      <Field
        name="email"
        label="Email"
        type="email"
        fullWidth
        component={FormTextField}
        validate={emailFieldValidation}
      />
      <StyledButton variant="raised" color="primary" type="submit" fullWidth>
        Send email
      </StyledButton>
      {error && <FormError msg={error} />}
    </StyledForm>
  </StyledPaper>
);

export default reduxForm({
  form: 'forgotPasswordForm'
})(forgotPasswordForm);
